import React, { useState } from "react";
import { IPlayer, Storage } from "./storage";

export function PlayerManagement() {
  const [players, setPlayers] = useState<IPlayer[]>(Storage.getPlayers());
  const [newPlayerName, setNewPlayerName] = useState("");
  const [selectedPlayerId, setSelectedPlayerId] = useState<string | null>(null);
  const [newPosition, setNewPosition] = useState<number | null>(null);

  const addPlayer = () => {
    if (!newPlayerName.trim()) return;

    const newPlayer: IPlayer = {
      id: Date.now().toString(),
      name: newPlayerName,
      currentPosition: "",
      note: "",
      tags: [],
    };

    const updatedPlayers = [...players, newPlayer];
    setPlayers(updatedPlayers);
    Storage.savePlayers(updatedPlayers);
    setNewPlayerName("");
  };

  const updatePlayerPosition = () => {
    if (
      !selectedPlayerId ||
      newPosition === null ||
      newPosition < 1 ||
      newPosition > 9
    )
      return;

    const updatedPlayers = players.map((player) =>
      player.id === selectedPlayerId
        ? { ...player, currentPosition: newPosition.toString() }
        : player
    );

    setPlayers(updatedPlayers);
    Storage.savePlayers(updatedPlayers);
    setSelectedPlayerId(null);
    setNewPosition(null);
  };

  return (
    <div>
      <h1>Player Management</h1>
      <div>
        <a href="/poker">Tells</a>
        <br />
        <a href="/add-tell">Add tell</a>
      </div>
      <div>
        <h2>Add New Player</h2>
        <input
          type="text"
          placeholder="Enter player name"
          value={newPlayerName}
          onChange={(e) => setNewPlayerName(e.target.value)}
        />
        <button onClick={addPlayer}>Add Player</button>
      </div>

      <div>
        <h2>Set Player Position</h2>
        <select
          value={selectedPlayerId || ""}
          onChange={(e) => setSelectedPlayerId(e.target.value)}
        >
          <option value="" disabled>
            Select Player
          </option>
          {players.map((player) => (
            <option key={player.id} value={player.id}>
              {player.name}
            </option>
          ))}
        </select>
        <input
          type="number"
          placeholder="Enter position (1-9)"
          value={newPosition || ""}
          onChange={(e) => setNewPosition(Number(e.target.value))}
        />
        <button onClick={updatePlayerPosition}>Set Position</button>
      </div>

      <div>
        <h2>All Players</h2>

        <ul>
          {players.map((player) => (
            <li key={player.id}>
              {player.name} - Position: {player.currentPosition || "Not set"}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
